import React from 'react';
import './App.css';
import PublicRouter from "./Router/PublicRouter"  
function App() {
  return (
    <div className="App"> 
      <PublicRouter/>
    </div>
  );
}

export default App;
